import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { TelephonyProvider } from '../../providers/telephony/telephony.provider';
import { TelephonyStateService } from '../../providers/telephony/telephony.state.service';
import { CallService } from '../../services/call.service';
import { DialpadService } from '../../services/dialpad.service';
import { NavService } from '../../services/nav.service';
import { TelephonyService } from '../../providers/telephony/telephony.service';
import { AgentStatusService } from '../../services/agentstatus.service';
import { CampaignService } from '../../services/campaign.service';
import { Constants } from '@app/constants';
import { ToastService } from '../../services/toast/toast.service';
import { ThemesService } from '../../features/setting/services/themes.service';
import { naturalSensitiveSort } from '../../utils/sort';
import { ProviderService } from '../../services/provider.service';
import { ConnectionService } from '../../services/network.service';
import { Subscription } from 'rxjs';
import { Validators } from '@angular/forms';
import momentTimezone from 'moment-timezone';
import moment from 'moment';
import { AppConfigurationService } from '../../services/app.configuration.service';
import { AlertService } from '../../services/alert.service';
@Component({
  selector: 'app-dial-pad',
  templateUrl: './dial-pad.component.html',
})
export class DialPadComponent implements OnInit, OnDestroy {
  constructor(
    public dialpadService: DialpadService,
    private authService: AuthenticationService,
    public telephony: TelephonyProvider,
    public t: TelephonyService,
    public telephonyStateService: TelephonyStateService,
    public callService: CallService,
    private statusService: AgentStatusService,
    public campaignService: CampaignService,
    private toastService: ToastService,
    public themeService: ThemesService,
    public providerService: ProviderService,
    private internetService: ConnectionService,
    private appConfig: AppConfigurationService,
    private alertService: AlertService
  ) { }

  addons = [];
  searchNumber = '';
  isContactOpen = false;
  timezones = [{ Value: 'EST' }, { Value: 'PT' }, { Value: 'CT' }, { Value: 'MT' }];
  public KEYPADS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
  public viewMore: boolean = false;
  numbers: any[] = [];
  hasInternetAccess = false;
  private internetSubscription = new Subscription();
  public callbackConfig = {
    minDate: new Date(),
    timeZones: [
      { name: 'Eastern', value: 'EST' },
      { name: 'Central', value: 'CT' },
      { name: 'Mountain', value: 'MT' },
      { name: 'Pacific', value: 'PT' }
    ],
    hours: Array.from({ length: 24 }, (_, i) => i + 1),
    minutes: Array.from({ length: 4 }, (_, i) =>
      (i * 15).toString().padStart(2, '0')
    ),
  };
  ngOnInit(): void {
    this.numbers = this.campaignService.transferNumbers;
    this.addons = naturalSensitiveSort(this.campaignService.metadata.Addons).asc('Name' as any) as any;
    this.internetSubscription.add(
      this.internetService.stateChanged$.subscribe((state) => {
        this.hasInternetAccess = state.hasInternetAccess;
      })
    );

  }
  async dialCall() {
    if (!this.hasInternetAccess) {
      this.toastService.error('No internet connection available. Please check your internet connection and try again');
      return;
    }
    let res = await this.authService.fetchTodayCallbacksCount();
    const count = res?.length > 0 ? res[0].count : 0;
    const limit = this.appConfig.getByIdentifier('ScriptSkillCodesAndTFNS').Fields['CALL_BACK_CALLS_LIMIT'] ?? 15;

    let isLimitReached: boolean = count === limit;
    if (isLimitReached) {
      this.toastService.warning('Maximum number of Callback reached');
      return;
    }
    const campaigns = this.authService.getAllCampaignCode();
    const code = campaigns ? campaigns[0] : '';
    //* TRACK OutboundCallResitriction for specific time
    if (this.telephonyStateService.isOutboundCallRestriction(code)) {
      return;
    }
    if (this.dialpadService.callEnabled)
      this.telephony.voice.makeCall(
        null,
        `${this.campaignService.countryCode}` + this.dialpadService.number,
        'outbound',
        {},
        '',
        '',
        '',
        '',
        'dialpad'
      );
  }
  endCall() {
    if (!this.hasInternetAccess) {
      this.toastService.error('No internet connection available. Please check your internet connection and try again');
      return;
    }
    if (this.statusService.currentStatus.FriendlyName == Constants.STATUSES.Hold.FriendlyName) {
      this.toastService.info('Cannot end the call, Please resume first');
      return;
    }

    this.campaignService.applyFormTouch();
    let validSale = this.campaignService.isFormValid(this.campaignService.salesForm);
    let valid = false;
    switch (this.campaignService.stepperIndex) {
      case 0:
        valid = this.campaignService.isFormValid(this.campaignService.greetingForm);
        if (valid && validSale) {
          if (!this.addonsCheck()) return;

          this.telephony.voice.endCall(null, true);
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
        } else {
          this.telephony.voice.endCall(null, false);
          if (!this.pkAddonsToCheck()) return;
        }
        break;
      case 1:
      case 2:
        valid =
          this.campaignService.isFormValid(this.campaignService.greetingForm) &&
          this.campaignService.isFormValid(this.campaignService.addressForm);
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          this.telephony.voice.endCall(null, true);
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
        } else {
          this.telephony.voice.endCall(null, false);
          if (!this.pkAddonsToCheck()) return;
        }
        break;
      case 3:
        valid =
          this.campaignService.isFormValid(this.campaignService.greetingForm) &&
          this.campaignService.isFormValid(this.campaignService.addressForm) &&
          validSale;
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          if (!this.chatTfnCheck()) return;
          this.telephony.voice.endCall(null, true);
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
        } else {
          this.telephony.voice.endCall(null, false);
          if (!this.campaignService.dispositionForm.valid && this.campaignService.showChatTfnTextbox) {
            if (!this.campaignService.dispositionForm.controls['chatTfn'].valid) {
              this.toastService.info('Chat TFN is required. Please enter a valid Chat TFN from the dialpad');

            }
          }
          if (!this.pkAddonsToCheck()) return;
        }
        break;
    }
  }
  disposeCall() {
    if (!this.hasInternetAccess) {
      this.toastService.error('No internet connection available. Please check your internet connection and try again');
      return;
    }
    this.campaignService.logCampaignScripts();
    this.campaignService.navigateToCampaignRoute();
    this.campaignService.applyFormTouch();

    if (!this.pkAddonsToCheck()) return;

    let valid = false;
    let validSale = this.campaignService.isFormValid(this.campaignService.salesForm);
    if (!validSale && this.callBackTimeZoneValidation()) {
      return
    }
    switch (this.campaignService.stepperIndex) {
      case 0:
        valid = this.campaignService.isFormValid(this.campaignService.greetingForm);
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
          return;
        }
        break;
      case 1:
      case 2:
        valid =
          this.campaignService.isFormValid(this.campaignService.greetingForm) &&
          this.campaignService.isFormValid(this.campaignService.addressForm);
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
          return;
        }
        break;
      case 3:
        valid =
          this.campaignService.isFormValid(this.campaignService.greetingForm) &&
          this.campaignService.isFormValid(this.campaignService.addressForm) &&
          validSale;
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
          return;
        }
        break;
    }

    if (valid && this.campaignService.dispositionForm.valid) {
      this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
    }
    else {
      if (!this.campaignService.dispositionForm.valid && this.campaignService.showChatTfnTextbox) {
        if (!this.campaignService.dispositionForm.controls['chatTfn'].valid) {
          this.toastService.info('Chat TFN is required and should be a valid phone number');
        }
      }
    }
  }
  toggleViewMore(): void {
    this.viewMore = !this.viewMore;
  }
  onClickOutSide(): void {
    this.viewMore = false;
  }
  muteCall() {
    this.telephony.voice.muteUnMuteCall(null);
  }
  conferenceCall() {
    if (this.dialpadService.number?.length != 10) {
      this.toastService.error('Please enter a valid number before proceeding.');
      return;
    }
    if (this.telephonyStateService.onHold) {
      this.toastService.error('Cannot conference call while it is on hold.');
      return;
    }
    let number = this.campaignService.countryCode + this.dialpadService.number;
    if (!this.telephonyStateService.isOperationAllowed(number, 'Conference')) {
      this.toastService.error('Operation not allowed on this number at this time.');
      return;
    }
    if (this.dialpadService.conferenceEnabled) {
      this.telephony.voice.conferenceCall(null, number, this.telephonyStateService.onConsultancy);
    }
  }
  consultCall() {
    if (this.dialpadService.number?.length != 10) {
      this.toastService.error('Please enter a valid number before proceeding.');
      return;
    }
    if (this.telephonyStateService.onHold) {
      this.toastService.error('Cannot consult call while it is on hold.');
      return;
    }
    let number = this.campaignService.countryCode + this.dialpadService.number;
    if (!this.telephonyStateService.isOperationAllowed(number, 'Consult')) {
      this.toastService.error('Operation not allowed on this number at this time.');
      return;
    }
    if (this.dialpadService.consultEnabled) {
      this.telephony.voice.consultCall(null, number, this.telephonyStateService.onConference);
    }
  }
  toggleCall() {
    if (this.telephonyStateService.onHold) {
      this.toastService.error('Cannot toggle call while it is on hold.');
      return;
    }
    if (this.dialpadService.toggleEnabled) {
      let number = this.campaignService.countryCode + this.dialpadService.number;
      this.telephony.voice.toggleCall(
        null,
        this.telephonyStateService.onToggle,
        this.telephonyStateService.onConsultancy,
        this.telephonyStateService.onConference,
        number
      );
    }
  }
  canceThirdPartyCall() {
    if (this.dialpadService.cancelEnabled) {
      this.telephony.voice.endThirdPartyCall(null, this.telephonyStateService.onConsultancy);
    }
  }
  holdCall() {
    if (!this.telephonyStateService.onHold && this.alertService.isAnyAlertExist('Hold')) {
      this.toastService.info(`Please mark the Hold alert as acknowledge and try again`);
      return;
    }
    if (this.dialpadService.holdResumeEnabled) this.telephony.voice.holdCall(null, this.telephonyStateService.onHold);
  }
  transferCall() {
    if (this.dialpadService.number?.length != 10) {
      this.toastService.error('Please enter a valid number before proceeding.');
      return;
    }
    if (this.telephonyStateService.onHold) {
      this.toastService.error('Cannot transfer call while it is on hold.');
      return;
    }
    let number = this.campaignService.countryCode + this.dialpadService.number;
    if (!this.telephonyStateService.isOperationAllowed(number, 'Consult')) {
      this.toastService.error('Operation not allowed on this number at this time.');
      return;
    }
    if (this.dialpadService.transferEnabled) {
      this.telephony.voice.transferCall(
        null,
        number,
        this.telephonyStateService.onConsultancy,
        this.telephonyStateService.onConference
      );
    }
  }
  toggleContactOpen() {
    this.isContactOpen = !this.isContactOpen;
  }
  getName(name: string) {
    if (!name) {
      return;
    }
    return name.substring(0, 1).toUpperCase() + '' + name.substring(name.length - 1, name.length).toUpperCase();
  }
  setTransferNumber(number: string) {
    this.dialpadService.setKeypad(true);
    this.dialpadService.setNumber(number.replace('+1', ''));
    this.toggleContactOpen();
    this.numbers = this.campaignService.transferNumbers;
    this.searchNumber = '';
  }
  onNumberSearch(number: string) {
    this.numbers = this.campaignService.transferNumbers.filter((x: any) => x.Name.indexOf(number) !== -1);
  }
  ngOnDestroy(): void {
    this.internetSubscription.unsubscribe();
  }
  addonsCheck() {
    if (this.campaignService.isFECallAndFEAddonsNotSelected()) {
      this.toastService.info('Please select FE addons first');
      return false;
    }
    //* PK Addons Validation Check
    if (this.campaignService.isPKCallAndIsSaleAndPKAddonsNotSelected()) {
      this.toastService.info('Please select Home Security addons first');
      return false;
    }
    //* AutoPay Addons Validation Check
    if (this.campaignService.isPortmoreCallAndIsSaleAndAutoPayAddonsNotSelected()) {
      this.toastService.info('Please select AUTO-PAY addons first');
      return false;
    }

    const serviceableProviderAddon = this.campaignService.isSaleAndBDServiceableProvidersAddonsNotSelected();
    if (!serviceableProviderAddon.isSelected) {
      serviceableProviderAddon.warning.forEach(e => {
        this.toastService.info(e);
      });
      return false;
    }
    return true;
  }
  chatTfnCheck() {
    if (this.campaignService.isChatSkillCall && this.campaignService.isFormValid(this.campaignService.salesForm)) {
      this.campaignService.salesForm.controls['chatTfn'].clearValidators();
      this.campaignService.salesForm.controls['chatTfn'].setValidators([Validators.required, this.campaignService.phoneValidator]);
      this.campaignService.salesForm.controls['chatTfn'].updateValueAndValidity();

      if (this.campaignService.salesForm.controls['chatTfn'].valid) {
        return true;
      };
      this.toastService.info('Chat TFN is required and should be a valid phone number');
      return false;
    }
    return true;
  }
  pkAddonsToCheck() {
    //* PK Addons Validation Check
    if (this.campaignService.isPKCallAndIsSaleAndPKAddonsNotSelected()) {
      this.toastService.info('Please select Home Security addons first');
      return false;
    }
    return true;
  }


  private callBackTimeZoneValidation() {
    const isCallBack = this.campaignService.dispositionCallbackSelection === 'Callback Scheduled';
    if (isCallBack) {
      const callbackTimezone = this.campaignService.dispositionForm.get('callbackTimezone')?.value;
      const callbackDate = this.campaignService.dispositionForm.get('callbackDate')?.value;
      const callbackHour = this.campaignService.dispositionForm.get('callbackHour')?.value;
      const callbackMins = this.campaignService.dispositionForm.get('callbackMins')?.value;
      // callbackDate = new Date(callbackDate)
      const fields = [
        [callbackTimezone, 'timezone'],
        [callbackDate, 'date'],
        [callbackHour, 'hour'],
        [callbackMins, 'minutes'],
      ] as const;

      for (const [value, name] of fields) {
        if (!value) {
          this.toastService.info(`Please select ${name}`);
          return false;
        }
      }
      console.log(`${callbackDate.getDate()} ${callbackDate.getMonth() + 1} ${callbackDate.getFullYear()} ${callbackHour}:${callbackMins}`)
      const day = callbackDate.getDate();
      const month = callbackDate.getMonth();
      const year = callbackDate.getFullYear();
      const hour = Number(callbackHour);
      const minute = callbackMins;

      const timeZone: Record<string, string> = {
        'EST': 'America/New_York',
        'CT': 'America/Chicago',
        'MT': 'America/Denver',
        'PT': 'America/Los_Angeles'
      };
      const formatted = moment.tz({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: +minute
      }, timeZone[callbackTimezone]).format('MMMM Do YYYY, h:mm:ss a');

      const callbackTime = this.getTimeZoneDate(formatted, callbackTimezone);
      const currentTime = this.getTimeZoneMOment(callbackTimezone);

      if (callbackTime.isBefore(currentTime)) {
        this.toastService.error("Validation Error: Selected time is in the past for timezone:", callbackTimezone);
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  private getTimeZoneMOment(timeZone: string): momentTimezone.Moment {
    switch (timeZone) {
      case 'EST':
        return momentTimezone().tz('America/New_York');
      case 'CT':
        return momentTimezone().tz('America/Chicago');
      case 'MT':
        return momentTimezone().tz('America/Denver');
      case 'PT':
        return momentTimezone().tz('America/Los_Angeles');
      default:
        return momentTimezone();
    }
  };

  private getTimeZoneDate(datetime: string, timeZone: string): momentTimezone.Moment {
    switch (timeZone) {
      case 'EST':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/New_York');
      case 'CT':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/Chicago').tz('America/New_York');
      case 'MT':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/Denver').tz('America/New_York');
      case 'PT':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/Los_Angeles').tz('America/New_York');
      default:
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/New_York');
    }
  };

  public updateMinDate(timeZoneKey: string): void {
    const TIMEZONE_MAP: Record<string, string> = {
      'EST': 'America/New_York',
      'CT': 'America/Chicago',
      'MT': 'America/Denver',
      'PT': 'America/Los_Angeles'
    };
    const tzName = TIMEZONE_MAP[timeZoneKey];
    if (!tzName) return;
    const tzMoment = momentTimezone().tz(tzName);
    const newMinDate = new Date(
      tzMoment.year(),
      tzMoment.month(),
      tzMoment.date(),
      0, 0, 0, 0
    );

    this.callbackConfig.minDate = newMinDate;
    const currentDateControl = this.campaignService.dispositionForm.get('callbackDate');
    if (currentDateControl?.value && new Date(currentDateControl.value) < newMinDate) {
      currentDateControl.setValue(null);
    }
  }
}
